// @ts-ignore
export * as Turbo from '@hotwired/turbo';

// @ts-ignore
window.Turbo.session.drive = false;
